export const NOTIFICATION_PLACEHOLDER_COLOR = '#E0E0E0';
export const UPDATE_DISPLAY_TIME_INTERVAL = 1000;
export const PAGE_SIZE = 4;
export const DEBOUNCE_IN_MILLIS = 500;
export const NOTIFICATION_TYPES = {
  NO_AVAILABLE_TUNNEL: 'NO_AVAILABLE_TUNNEL',
  TUNNEL_ERROR: 'TUNNEL_ERROR',
  LIMIT_QUOTA: 'LIMIT_QUOTA',
};
